import { Typography, Button } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

type Props = {
  onCloseDialog: () => void
}

export const NoTherapistsAvailable = ({ onCloseDialog }: Props) => {
  const styles = useStyles()
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="h2" component="h2" className={styles.text}>
          No therapists available within the next two weeks
        </Typography>

        <Typography variant="h3" component="h3" className={styles.text}>
          We couldn&apos;t find any therapists who accept participant&apos;s insurance and are available in their area
          right now.
        </Typography>
      </div>

      <Button variant="contained" size="large" onClick={onCloseDialog} color="primary">
        Close
      </Button>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  text: {
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}))
